export enum Events {
	Chatbot = 'Chatbot',
	ConsentConfiguration = 'ConsentConfiguration',
	Shops = 'Shops',
}
